import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-压裂分析_井效果分析",
  "use": "icon-压裂分析_井效果分析-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-压裂分析_井效果分析\">\n<g>\n\t<polygon points=\"15.7,15.2 0.3,15.2 0.3,0.8 1.3,0.8 1.3,14.2 15.7,14.2 \t\" />\n\t<path d=\"M4.9,3.8v10.5H3.9V3.8H4.9 M5.7,3.1H3.1v12h2.6V3.1L5.7,3.1z\" />\n\t<path d=\"M9.2,8.5v5.8H8.1V8.5H9.2 M10,7.7H7.4V15H10V7.7L10,7.7z\" />\n\t<path d=\"M13.5,5.6v8.6h-1.1V5.6H13.5 M14.2,4.9h-2.6V15h2.6V4.9L14.2,4.9z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol